import DOMPurify from "dompurify";

// 前端这一层过滤，是配合后端 RichTextSanitizer 的"双保险"，不能因为后端已经过滤过了
// 就在前端省掉这一步——万一后端哪次改动漏了、或者数据是很早以前没过滤规则时存的老数据，
// 前端这道过滤能兜住，避免真的执行到恶意脚本。
// 规则跟后端保持一致：只放行加粗/斜体/下划线/标题/段落/列表/图片这些，危险标签和属性一律砍掉。
const SAFE_CONFIG = {
  ALLOWED_TAGS: [
    "p", "br", "b", "strong", "i", "em", "u", "font",
    "h1", "h2", "h3", "h4", "h5", "h6", "ul", "ol", "li", "img", "span",
  ],
  ALLOWED_ATTR: ["src", "alt", "style", "color"],
};

export function sanitizeRichText(html) {
  if (!html) return "";
  return DOMPurify.sanitize(html, SAFE_CONFIG);
}
